<template>
	<div class="contentPage">

		<template v-if="!isStatementCreateForm && !infoLoads">
			<main-table
					v-if="getStatementsList"
					:flag="flag"
					:pageTitle='title'
					:headers="headers"
					:listItems="getStatementsList"
					:filtersList="statementsFilter"
					@updateClickButton="onClickButton"
					@updateCreate="onCreate"
					@updateSearch="onFilter"
					@updateRefreshFilters="onFilter"
					@updateChangeSort="onFilter"
					:uniqId="uniqId"
					isExport
					@updateExport="onExport"
					isSettings
					@updateSettings="onSettingsOpen"
			></main-table>
		</template>

		<statement-create-form
				v-if="isStatementCreateForm"
				@backFromCreate="onBackFromCreate"
				@backToMainTB="onBackToMainTB"
		></statement-create-form>

		<view-all-loads
				v-if="infoLoads"
				:permissions="permissions"
				:allLoadsInfo="getInfoList"
				:filterLoads="getFilterLoads"
				:id="item.id"
				loadsFlag="all"
				v-on:backFromLoads="backFromLoads"
		></view-all-loads>

		<v-snackbar shaped top v-model="snackbar" elevation="24" vertical>
			Do you confirm the deletion?
			<v-card-actions>
				<v-flex d-flex justify-end>
					<v-btn small color="green" class="mt-0 ml-auto" text @click="deleteAction">Yes</v-btn>
					<v-btn small color="red" class="mt-0" text @click="snackbar = false">Close</v-btn>
				</v-flex>
			</v-card-actions>
		</v-snackbar>

		<table-settings
				v-if="isTableSettingsDrawer"
				@updateSettingsSave="onSettingsSave"
				@updateSettingsCancel="onSettingsCancel"
				@updateSettingsClose="onSettingsClose"
				@updateSettingsAll="onSettingsAll"
				:settings="settings"
		></table-settings>

	</div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
// components
import StatementCreateForm from './statements-create-form/statements-create-form.component';
import ViewAllLoads from './view-all-loads/view-all-loads.component';
const TableSettings = () => import("@/shared/TableSettings/TableSettings");
// constants
import { PERMISSIONS } from "@/constants/constants";
import getUniqId from "@/helper/getUniqId";

export default {
	components: {
		StatementCreateForm,
		ViewAllLoads,
		TableSettings
	},
	computed: {
		...mapGetters([
			'statementsFilter',
			'getStatementsList',
			'getInfoList',
			'getFilterLoads',
			'permissions',
			'statementsSettingsDefault',
			'statementsSettings',
			'statementsHeaders',
		]),
		settings() {
			return this.statementsSettings;
		},
		headers() {
			return this.statementsHeaders;
		}
	},
	data: () => ({
		itemRemove: null,
		snackbar: false,
		title: "Dispatchers statements",
		flag: 'dispatchersStatements',
		item: null,
		isStatementCreateForm: false,
		listItems: [],
		infoLoads: false,
		isTableSettingsDrawer: false,
		uniqId: null,
	}),
	mounted() {
		this.getList();
	},
	methods: {
		...mapActions([
			'updateStatementFilter',
			'getListOfStatements',
			'getListInfo',
			'deleteStatement',
			'onExportLink',
			'onStatementsSettingsReset',
			'onStatementsSettingsSave',
			'onStatementsSettingsAll',
		]),
		async onSettingsCancel() {
			this.onSettingsClose();
			await this.onStatementsSettingsReset();
		},
		onSettingsClose() {
			this.isTableSettingsDrawer = false;
		},
		async onSettingsSave() {
			await this.onStatementsSettingsSave();
			this.uniqId = getUniqId();
		},
		async onSettingsAll(value) {
			await this.onStatementsSettingsAll(value);
		},
		onSettingsOpen() {
			this.isTableSettingsDrawer = true;
		},
		async onExport(values) {
			await this.onExportLink({ values, requestKey: 'dispatcher/statement' });
		},
		onClickButton({ key, item }) {
			if (key === "openLoads") {
				this.item = item;
				this.openLoad(item);
			}
			if (key === "delete") {
				this.checkRemove(item);
			}
		},
		async openLoad(item) {
			if (this.permissions[PERMISSIONS.EDIT] || this.permissions[PERMISSIONS.VIEW] || this.permissions['19']) {
				this.infoLoads = true;
				await this.getListInfo(item.id);
			}
		},
		checkRemove(item) {
			this.itemRemove = item;
			this.snackbar = true;
		},
		async deleteAction() {
			await this.deleteStatement(this.itemRemove);
			this.snackbar = false;
			this.itemRemove = null;
		},
		async onFilter(info) {
			await this.updateStatementFilter(info.filterModList);
		},
		onCreate() {
			this.isStatementCreateForm = true;
			this.infoLoads = false;
		},
		async deleteItem(item) {
			await this.deleteStatement(item);
		},
		onBackToMainTB() {
			this.infoLoads = false;
			this.isStatementCreateForm = false;
			this.getList();
		},
		backFromLoads() {
			this.infoLoads = false;
		},
		onBackFromCreate() {
			this.isStatementCreateForm = false;
			this.infoLoads = false;
		},
		async getList() {
			await this.getListOfStatements();
		}
	}
};
</script>
